import * as actions from './betaStationConstant.js'
const initialState = {
    betStationResp: {},
}

const betaStationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.GET_BETA_STATION_SUCCESS: {
            return {
                ...state,
                betStationResp: action.data,
            }
        }
        default:
            return state;
    }
}


export default betaStationReducer;
